import _get from 'lodash/get';

import { Pixall } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById } from '@/analytics/utilities';

/**
 * @summary Sends Pixall event when clicking Back to results link Button
 * @events event168
 */
export function backToResultsLinkClick(metadata, option) {
    const {
        data = {},
        dataLayer = {},
        state,
    } = metadata;

    const { inventoryId } = data;
    const inventory = getInventoryOwnerById(state, inventoryId);
    const pageId = _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '');

    Pixall.sendClickEvent({
        pageType: 'vdp',
        eventType: 'click',
        pageId,
        label: 'back-to-results',
        eventSource: 'link',
        inventory,
        ignorePageTag: true,
    }, dataLayer, option);

    return { };
}
